import http, { apiErrorMessage } from '../../http';

const vRutaRecolecciones = 'recolecciones';

export const LimpiarRecolecciones = () =>{
    return (dispatch, getState) => {
        dispatch({type: "RECOLECCION_RECOLECCIONES_LIMPIAR_DATA"});
    }
}

export const getTotales = (fecha, sucursal) => {
    return (dispatch, getState) => {
        http.get(vRutaRecolecciones + '/totales', { params: { fecha, sucursal } })
            .then(function (response) {
                // Envelope v1: {data:{transmitidas,realizadas,canceladas}}
                dispatch({
                    type: "RECOLECCION_TOTALES_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'RECOLECCION_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}

export const getRecolecciones = (fecha, sucursal, estado) => {
    return (dispatch, getState) => {
        http.get(vRutaRecolecciones, { params: { fecha, sucursal, estado, recolecciones: 'si' } })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "RECOLECCION_RECOLECCIONES_LIST_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'RECOLECCION_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}

export const getListForTable = (fecha, sucursal) => {
    return (dispatch, getState) => {
        http.get(vRutaRecolecciones, { params: { fecha, sucursal } })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "RECOLECCION_LIST_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'RECOLECCION_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}
